import React from 'react';
import './CardEstadisticas.css';

const CardEstadisticas = () => {
  const tarjetas = [
    {
      id: 1,
      numero: 7,
      label: 'Formacion Tecnico laboral',
      icon: (
        <svg viewBox="0 0 24 24" className="stat-icon" fill="currentColor">
          <path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 4h6v2H9V4zm9 16H6V8h12v12zm-2-8H8v-2h8v2zm0 4H8v-2h8v2z" />
        </svg>
      )
    },
    {
      id: 2,
      numero: 1,
      label: 'Diplomado',
      icon: (
        <svg viewBox="0 0 24 24" className="stat-icon" fill="currentColor">
          <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z" />
        </svg>
      )
    },
    {
      id: 3,
      numero: 0,
      label: 'virtual',
      icon: (
        <svg viewBox="0 0 24 24" className="stat-icon" fill="currentColor">
          <path d="M12 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm-8 16c0-2.67 5.33-4 8-4s8 1.33 8 4v2H4v-2zm17-10h-6v2h6V8zm0 4h-6v2h6v-2z" />
        </svg>
      )
    },
    {
      id: 4,
      numero: 2,
      label: 'Cursos',
      icon: (
        <svg viewBox="0 0 24 24" className="stat-icon" fill="currentColor">
          <path d="M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z" />
        </svg>
      )
    }
  ];

  return (
    <section className="stats-container">
      <div className="stats-grid">
        {tarjetas.map((tarjeta) => (
          <div key={tarjeta.id} className="stat-card">
            <div className="stat-icon-wrapper">
              {tarjeta.icon}
            </div>
            <span className="stat-number">{tarjeta.numero}</span>
            <span className="stat-label">{tarjeta.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CardEstadisticas;
